import { BLACK } from "../puzzles/colors";
import { PolygonRenderer } from "./polygonRenderer";
export class HtmlCanvasRenderer extends PolygonRenderer {
    constructor(width, height, lineWidth = 5, arrowColor = BLACK) {
        super();
        this.width = width;
        this.height = height;
        this.lineWidth = lineWidth;
        this.arrowColor = arrowColor;
        this.domElement = document.createElement("div");
        this.domElement.className = "canvas-renderer";
        this.canvasElement = document.createElement("canvas");
        this.domElement.appendChild(this.canvasElement);
        this.canvasElement.width = width;
        this.canvasElement.height = height;
        this.ctx = this.canvasElement.getContext("2d");
    }
    /**
     * Visualizer point values will be in range (-.9, .9)
     * Convert these values to canvas points (0, imgSize)
     * using linear interpolation
     *
     * really the camera matrix should be set up properly
     * so we don't have to do this...
     */
    convertRange(n, range) {
        return ((n - -0.9) / (0.9 - -0.9)) * range;
    }
    onBeforeRender() {
        this.ctx.clearRect(0, 0, this.width, this.height);
    }
    drawPolygon(polygon) {
        var _a, _b;
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.lineJoin = "round";
        this.ctx.fillStyle = ((_b = (_a = polygon === null || polygon === void 0 ? void 0 : polygon.face) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.value) || "#000000";
        this.ctx.strokeStyle = "#000000";
        this.ctx.moveTo(this.convertRange(polygon.points[0].x, this.width), this.convertRange(polygon.points[0].y, this.height));
        this.ctx.beginPath();
        for (let i = 0; i <= polygon.points.length; i++) {
            let point = polygon.points[(i + 1) % polygon.points.length];
            this.ctx.lineTo(this.convertRange(point.x, this.width), this.convertRange(point.y, this.height));
        }
        this.ctx.closePath();
        this.ctx.fill();
        this.ctx.stroke();
    }
    drawArrow(p1, p2, uid) {
        const toX = this.convertRange(p2.x, this.width);
        const toY = this.convertRange(-p2.y, this.height);
        const fromX = this.convertRange(p1.x, this.width);
        const fromY = this.convertRange(-p1.y, this.height);
        const headlen = 20; // length of head in pixels
        const dx = toX - fromX;
        const dy = toY - fromY;
        const angle = Math.atan2(dy, dx);
        this.ctx.strokeStyle = this.arrowColor.value;
        this.ctx.beginPath();
        this.ctx.moveTo(fromX, fromY);
        this.ctx.lineTo(toX, toY);
        this.ctx.lineTo(toX - headlen * Math.cos(angle - Math.PI / 6), toY - headlen * Math.sin(angle - Math.PI / 6));
        this.ctx.moveTo(toX, toY);
        this.ctx.lineTo(toX - headlen * Math.cos(angle + Math.PI / 6), toY - headlen * Math.sin(angle + Math.PI / 6));
        this.ctx.stroke();
    }
    setLineWidth(lineWidth) {
        this.lineWidth = lineWidth;
    }
    onComplete() { }
}
